import { createStyles, makeStyles, styled, Typography } from '@material-ui/core';
import { TextInput } from '@room-match/shared-ui-components';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_BUTTON_BACKGROUND,
  DARK_DIALOG_FIELDS_FLOATING,
  DARK_TEXT,
  DARK_TEXTBOX_BACKGROUND,
  DARK_TEXTBOX_BORDER,
  LIGHT_DIALOG_FIELDS_FLOATING,
  LIGHT_TEXTBOX_BACKGROUND,
  LIGHTER_BUTTON_BACKGROUND,
  PLAIN_ICON,
  PLAIN_TEXT,
  PRIMARY_BUTTON_BORDER,
  PRIMARY_ICON,
  PRIMARY_TEXTBOX_BORDER_FOCUS,
} = COLORS;

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      maxWidth: 485,
      width: '100%',
      margin: '0 auto',
      '& .MuiPaper-root': {
        width: '100%',
      },
    },
    close: {
      position: 'absolute',
      top: 15,
      right: 15,
    },
    icon: {
      fontSize: 40,
      marginBottom: 10,
    },
    other: {
      width: 40,
    },
    doc: {},
    content: {
      width: '100%',
      backgroundColor: theme.palette.type === 'dark' ? DARK_DIALOG_FIELDS_FLOATING : LIGHT_DIALOG_FIELDS_FLOATING,
      padding: 20,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',

      '& .MuiSvgIcon-root': {
        '&.documentIcon path': {
          fill: PRIMARY_ICON,
        },
      },
    },

    buttonContainer: {
      width: '100%',
      textAlign: 'center',
      marginTop: 30,
    },

    buttonCls: {
      height: '50px !important',
      borderRadius: 8,
      textTransform: 'unset',
      fontSize: 14,
      maxWidth: 345,

      '& .MuiSvgIcon-root': {
        fontSize: 16,
        marginRight: 7,

        '& path': {
          fill: PLAIN_ICON,
        },
      },
    },

    outlinedButtonCls: {
      marginTop: 20,
      background: DARK_BUTTON_BACKGROUND,
      border: `1px solid ${PRIMARY_BUTTON_BORDER}`,
    },

    uploadButton: {
      backgroundColor: theme.palette.type === 'dark' ? '' : LIGHTER_BUTTON_BACKGROUND,
    },
  }),
);

export const CustomTextInput = styled(TextInput)(({ theme }) => ({
  borderRadius: 8,
  '& .MuiInputBase-root': {
    background: theme.palette.type === 'dark' ? DARK_TEXTBOX_BACKGROUND : LIGHT_TEXTBOX_BACKGROUND,
    fontSize: 14,
    height: '50px',
  },
  '& .MuiFormHelperText-contained': {
    marginLeft: 0,
  },

  '& fieldset': {
    borderColor: DARK_TEXTBOX_BORDER,
    borderRadius: 8,
  },
  '&:hover fieldset': {
    borderColor: PRIMARY_TEXTBOX_BORDER_FOCUS,
  },
  '&.Mui-focused fieldset': {
    borderColor: PRIMARY_TEXTBOX_BORDER_FOCUS,
  },
}));

export const TextSwitchColor = styled(Typography)(({ theme, size, weight }: any) => ({
  color: theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
  fontWeight: weight || 500,
  fontSize: size || 16,
}));

export const TextGreyColor = styled(Typography)(({ theme, size }: any) => ({
  color: theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
}));
